import { memo } from "react";
import Svg, { Path, type SvgProps } from "react-native-svg";

const SvgClean = (props: SvgProps) => (
  <Svg fill="none" height={25} width={24} {...props}>
    <Path
      clipRule="evenodd"
      d="M20.2 24.5a6.7 6.7 0 0 1 1.772-2.593 6.7 6.7 0 0 1-1.772-2.593 6.7 6.7 0 0 1-1.771 2.593A6.7 6.7 0 0 1 20.2 24.5M3.8 7.337A6.7 6.7 0 0 1 5.57 4.744 6.7 6.7 0 0 1 3.8 2.151a6.7 6.7 0 0 1-1.771 2.593 6.7 6.7 0 0 1 1.771 2.593M12 24.5q.496-1.309 1.104-2.558A31 31 0 0 1 20.2 12.5 31.021 31.021 0 0 1 12 .5q-.496 1.309-1.104 2.558A31 31 0 0 1 3.799 12.5a31.1 31.1 0 0 1 8.2 12m0-4.78a33 33 0 0 1 5.321-7.22A33 33 0 0 1 12 5.28a33 33 0 0 1-5.321 7.22 33 33 0 0 1 5.32 7.22"
      fill={props.color}
      fillRule="evenodd"
    />
  </Svg>
);
const Memo = memo(SvgClean);
export default Memo;
